export default __webpack_public_path__ + "static/media/EN_06.a381a1e2.svg";